import React, { FC, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import SpreadsheetColumnSwitcherTooltip from './SpreadsheetColumnSwitcherTooltip';
import { useSpreadsheetColumnSwitcherDispatch, useSpreadsheetColumnSwitcherDynamicState } from './const';
import { closeActiveTooltip, TooltipBtn } from '../../../../../../../ReactSharedScripts/components/TooltipBtn';
import { EllipsisH } from '../../../../../../../ReactSharedScripts/components/Icons/EllipsisH';
import { GeneralListColumn, isVisibleColumn } from '../../../../../../../ReactSharedScripts/modules/list';
import { CheckboxItem } from '../../../../../../../ReactSharedScripts/components/CheckboxGroup/types';
import generalClasses from '../styles/index.module.scss';
import classes from '../columnSwitcherStyles/index.module.scss';

type SpreadsheetColumnSwitcherProps = {
	className?: string;
	items: GeneralListColumn[];
	lightButton?: boolean;
	disabled?: boolean;
};

export const SpreadsheetColumnSwitcher: FC<SpreadsheetColumnSwitcherProps> = ({
	className,
	items,
	lightButton = false,
	disabled,
}) => {
	const { onTempChange, onChange } = useSpreadsheetColumnSwitcherDispatch();

	const componentClasses = classNames(generalClasses.headRowItemColumnSwitcher, className);
	const columnSwitcherInnerSectionClasses = classNames(classes.columnSwitcherInnerSection);
	const columnSwitcherButtonClasses = classNames(classes.columnSwitcherButton, {
		[classes.columnSwitcherButton_lightButton]: lightButton,
	});
	const { tempSelectedItems } = useSpreadsheetColumnSwitcherDynamicState();

	const tooltipColumns = useMemo<Array<CheckboxItem>>(() => {
		return items
			.filter((i) => !i.isRequired)
			.map(
				(item) => ({
					...item,
					id: item.name,
					label: item.title,
					checked: isVisibleColumn(item, tempSelectedItems),
				}),
				[],
			);
	}, [items, tempSelectedItems]);
	const hasSortingItems = tooltipColumns.length > 0;

	const handleApplyButtonClick = useCallback(() => {
		onChange();
		closeActiveTooltip();
	}, [onChange]);

	if (!hasSortingItems) {
		return null;
	}

	return (
		<div className={componentClasses}>
			<div className={columnSwitcherInnerSectionClasses}>
				<TooltipBtn
					disabled={disabled}
					className={columnSwitcherButtonClasses}
					styledButton={false}
					tooltip={
						<SpreadsheetColumnSwitcherTooltip
							tooltipColumns={tooltipColumns}
							onTempChange={onTempChange}
							onApplyButtonClick={handleApplyButtonClick}
						/>
					}
					onClose={onChange}
					tooltipAlign='end'
					ariaLabel='toggle columns settings'
				>
					<EllipsisH />
				</TooltipBtn>
			</div>
		</div>
	);
};
